module.exports = "pegasus_template/assets/themelp1/product/101.png";